import React, { useEffect, useState, useRef } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Styles from "../Style/Common.module.css";
import $ from "jquery";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import WorldOffice from "./TataMap/WorldMap";
import CorporateMap from "./TataMap/CorporateMap";
import BranchOffice from "./TataMap/BranchMap";
import SubsidiariesMap from "./TataMap/SubsidiariesMap";
import JointVentureOffice from "./TataMap/JointVentureMap";
import RepresentativeOffice from "./TataMap/RepresentativeMap";
import DeliveryLocationsOffice from "./TataMap/DeliveryMap";
import AfricaOffice from "./TataMap/DeliveryLocation/AfricaMap";
import AsiaOffice from "./TataMap/DeliveryLocation/AsiaMap";
import EuropeOffice from "./TataMap/DeliveryLocation/EuropeMap";
import NorthAmericaOffice from "./TataMap/DeliveryLocation/NorthAmericaMap";
import SouthAmericaOffice from "./TataMap/DeliveryLocation/SouthAmericaMap";
import AustraliaOffice from "./TataMap/DeliveryLocation/AustraliaMap";
import { FaLocationDot } from "react-icons/fa6";

const Global = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [showDeliveryLocations, setShowDeliveryLocations] = useState(false);
  return (
    <div className={"globalView " + Styles.GlobalSec}>
      <Tabs
        className="globalTabs"
        selectedIndex={tabIndex}
        onSelect={(index) => {
          setTabIndex(index);
          if (index === 6) {
            setShowDeliveryLocations(true);
          } else {
            setShowDeliveryLocations(false);
          }
        }}
      >
        <h3 className="gloabHead">Global Presence</h3>
        <TabList>
          <Tab><span className="icon"><FaLocationDot color="#636DAC" /></span> Office</Tab>
          <Tab><span className="icon"><img src={require('../../assest/images/office_icon.png')} /></span> Corporate Office</Tab>
          <Tab><span className="icon"><FaLocationDot color="#DA7E01" /></span> Branches</Tab>
          <Tab><span className="icon"><FaLocationDot color="#43A047" /></span> Subsidiaries</Tab>
          <Tab><span className="icon"><FaLocationDot color="#636DAC" /></span> Joint Venture</Tab>
          <Tab><span className="icon"><FaLocationDot color="#3A3A3A" /></span> Representative Office</Tab>
          <Tab><span className="icon"><FaLocationDot color="#E12C30" /></span> Delivery Locations</Tab>
        </TabList>

        <TabPanel>
          <WorldOffice />
        </TabPanel>
        <TabPanel>
          <CorporateMap />
        </TabPanel>
        <TabPanel>
          <BranchOffice />
        </TabPanel>
        <TabPanel>
          <SubsidiariesMap />
        </TabPanel>
        <TabPanel>
          <JointVentureOffice />
        </TabPanel>
        <TabPanel>
          <RepresentativeOffice />
        </TabPanel>
        <TabPanel>
          <div className="deliveryMap"></div>
        </TabPanel>
      </Tabs>
      {showDeliveryLocations && (
        <div className="deliveryLocations">
          <Tabs className="globalTabs">
            <TabList>
              <Tab><span className="icon"><FaLocationDot color="#E12C30" /></span> Africa</Tab>
              <Tab><span className="icon"><FaLocationDot color="#E12C30" /></span> Asia</Tab>
              <Tab><span className="icon"><FaLocationDot color="#E12C30" /></span> Europe</Tab>
              <Tab><span className="icon"><FaLocationDot color="#E12C30" /></span> North America</Tab>
              <Tab><span className="icon"><FaLocationDot color="#E12C30" /></span> South America</Tab>
              <Tab><span className="icon"><FaLocationDot color="#E12C30" /></span> Australia</Tab>
            </TabList>
            <TabPanel>
              <AfricaOffice />
            </TabPanel>              
            <TabPanel>
              <AsiaOffice />
            </TabPanel>
            <TabPanel>
              <EuropeOffice />
            </TabPanel>
            <TabPanel>
              <NorthAmericaOffice />
            </TabPanel>
            <TabPanel>
              <SouthAmericaOffice />
            </TabPanel>
            <TabPanel>
              <AustraliaOffice />
            </TabPanel>
          </Tabs>
        </div>
      )}
      {/* {showDeliveryLocations && (
        <div className="deliveryLocations">
          <h3>Delivery Locations</h3>
          <ul>
            <li className="mouseOver australiaCountry">Australia</li>
            <li className="mouseOver austriaCountry">Austria</li>
            <li className="mouseOver baharinCountry">Bahrain</li>
            <li className="mouseOver bangladeshCountry">Bangladesh</li>
            <li className="mouseOver belgiumCountry">Belgium</li>
            <li className="mouseOver brazilCountry">Brazil</li>
            <li className="mouseOver bulgariaCountry">Bulgaria</li>
            <li className="mouseOver canadaCountry">Canada</li>
            <li className="mouseOver chinaCountry">China</li>
            <li className="mouseOver croatiaCountry">Croatia</li>
            <li className="mouseOver RepublicCountry">Czech Republic</li>
            <li className="mouseOver DenmarkCountry">Denmark</li>
            <li className="mouseOver egyptCountry">Egypt</li>
            <li className="mouseOver FinlandCountry">Finland</li>
            <li className="mouseOver franceCountry">France</li>
            <li className="mouseOver germanyCountry">Germany</li>
            <li className="mouseOver greeceCountry">Greece</li>
            <li className="mouseOver hongkongCountry">Hong Kong</li>
            <li className="mouseOver hungaryCountry">Hungary</li>
            <li className="mouseOver indonesiaCountry">Indonesia</li>
            <li className="mouseOver irelandCountry">Ireland</li>
            <li className="mouseOver israelCountry">Israel</li>
            <li className="mouseOver italyCountry">Italy</li>
            <li className="mouseOver japanCountry">Japan</li>
            <li className="mouseOver russiaCountry">Russia</li>
            <li className="mouseOver sauArabCountry">Saudi Arabia</li>
            <li className="mouseOver senegalCountry">Senegal</li>
            <li className="mouseOver singaporeCountry">Singapore</li>
            <li className="mouseOver slovakiaCountry">Slovakia</li>
            <li className="mouseOver somalilandCountry">Somaliland</li>
            <li className="mouseOver southAfricaCountry">South Africa</li>
            <li className="mouseOver koreaCountry">South Korea</li>
            <li className="mouseOver spainCountry">Spain</li>
            <li className="mouseOver swedenCountry">Sweden</li>
            <li className="mouseOver switzerlandCountry">Switzerland</li>
            <li className="mouseOver taiwanCountry">Taiwan</li>
            <li className="mouseOver thailanCountry">Thailand</li>
            <li className="mouseOver tunisiaCountry">Tunisia</li>
            <li className="mouseOver turkeyCountry">Turkey</li>
            <li className="mouseOver UAECountry">United Arab Emirates</li>
            <li className="mouseOver UKCountry">United Kingdom</li>
            <li className="mouseOver USCountry">United States</li>
            <li className="mouseOver uzbekistanCountry">Uzbekistan</li>
            <li className="mouseOver vietnamCountry">Vietnam</li>
            <li className="mouseOver mexicoCountry">Mexico</li>
            <li className="mouseOver nepalCountry">Nepal</li>
            <li className="mouseOver netherlandCountry">Netherlands</li>
            <li className="mouseOver norwayCountry">Norway</li>
            <li className="mouseOver kenyaCountry">Kenya</li>
            <li className="mouseOver kuwaitCountry">Kuwait</li>
            <li className="mouseOver lithuaniaCountry">Lithuania</li>
            <li className="mouseOver luxembourgCountry">Luxembourg</li>
            <li className="mouseOver malaysaCountry">Malaysia</li>
            <li className="mouseOver omanCountry">Oman</li>
            <li className="mouseOver philippineCountry">Philippines</li>
            <li className="mouseOver polandCountry">Poland</li>
            <li className="mouseOver qatarCountry">Qatar</li>
            <li className="mouseOver romaniaCountry">Romania</li>
          </ul>
        </div>
      )} */}
    </div>
  );
};

export default Global;
